module.exports = __webpack_public_path__ + "img/495f6f2.png";